const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SEARCH":
      return { ...state, data: action.payload };

    case "SEARCH_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
